module.exports = __webpack_public_path__ + "a768e7de/img/rename-icon.de4e673d.svg";